import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import chartDonut from '@/components/charts/chartDonut/index.vue';
import preloader from '@/components/preloader/index.vue';
import pagination from '@/components/pagination/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  props: {
    lang: {
      type: Object,
      required: true,
    },
    managerList: {
      type: Array,
      default () {
        return [];
      },
    },
  },
  mixins: [
    helpers.random_color,
    helpers.work_with_date,
  ],
  components: {
    Multiselect,
    DatePicker,
    chartDonut,
    pagination,
    preloader,
    empty,
  },
  data () {
    return {
      errorsData: [],
      responseData: [],
      chartDonutData: {},

      params: {
        source_language: '',
        target_language: '',
        created_on: '',
        type: 'projects',
        manager: '',
        page: 1,
        ppage: 8,
      },

      rerenderKey: 0,
      load: true,
    };
  },
  watch: {
    'params.created_on' () {
      this.getAmountErrors();
    },
  },
  created () {
    this.getAmountErrors();
  },
  methods: {

    /**
         * Method return string for multiselect
         *
         * @param {Number} count
         */
    limitText (count) {
      return `and ${count} others manager`;
    },

    /**
         * Get list of errors
         */
    getAmountErrors () {
      this.refreshData();

      Api.dashboard.main
        .getAmount(this.transformParams())
        .then((data) => {
          this.responseData = data.data;
          this.errorsData = data.data.Data;

          if (this.errorsData.length != 0) {
            this.errorsData.forEach((el, index) => {
              index === 0 ? el.Checked = true : el.Checked = false;
            });

            this.drawChart();
          }

          this.load = false;
        });
    },

    /**
         * Refresh list of errors
         */
    refreshData () {
      this.load = true;
      this.chartDonutData = {};
    },

    /**
         * Method for toogle tab
         *
         * @param {String} type
         */
    changeTab (type) {
      this.params = {
        source_language: '',
        target_language: '',
        created_on: '',
        type: type,
        manager: '',
        page: 1,
        ppage: 8,
      };

      this.getAmountErrors();
    },

    /**
         * Method select type
         *
         * @param {String} type
         * @param {Object} event
         */
    selectItem (type, event) {
      this.params[type] = event;
      this.getAmountErrors();
    },

    /**
         * Method for remove select item
         *
         * @param {String} type
         */
    removeItem (type) {
      this.params[type] = '';
      this.getAmountErrors();
    },

    /**
         * Method for toggle graphs
         *
         * @param {Number} id
         */
    changeCheck (id) {
      this.errorsData.forEach((el) => {
        el.ID === id ? el.Checked = true : el.Checked = false;
      });

      this.drawChart();
    },

    /**
         * Draw graphs
         */
    drawChart () {
      this.$set(this.chartDonutData, 'inside', []);
      this.$set(this.chartDonutData, 'outside', []);

      this.errorsData.forEach((el) => {
        if (el.Checked) {
          const arInside = [{
            name: 'Major',
            y: el.MajorCount,
            color: this.generateColor(),
          }, {
            name: 'Minor',
            y: el.MinorCount,
            color: this.generateColor(),
          }];

          this.chartDonutData.inside.push(arInside[0]);
          this.chartDonutData.inside.push(arInside[1]);

          if (el.DetailErrorsData !== null) {
            el.DetailErrorsData.forEach((item) => {
              const arOutside = {
                name: item.Name,
                y: item.Count,
                color: this.generateColor(),
              };

              this.chartDonutData.outside.push(arOutside);
            });
          }
        }
      });

      this.rerenderKey = this.rerenderKey + 1;
    },

    /**
         * Send page and refresh list errors
         *
         * @param {Number} page
         */
    sendPage (page) {
      this.params.page = page;
      this.getAmountErrors();
    },

    /**
         * Transform params
         */
    transformParams () {
      const params = {
        source_language: this.params.source_language != '' ? this.params.source_language.ID : '',
        target_language: this.params.target_language != '' ? this.params.target_language.ID : '',
        created_on: this.convertDatePickerInUnix(this.params.created_on),
        type: this.params.type,
        manager: this.params.manager ? this.params.manager.ID : '',
        page: this.params.page,
        ppage: this.params.ppage,
      };

      return params;
    },

  },

};
